// Working Environment
type Env =
  | "local"
  | "sandbox"
  | "production"
export const ENV: Env = process.env.REACT_APP_ENV as Env
  || "sandbox";

// Manually set the token in the .env file when in the "local" environment
export const TOKEN = process.env.REACT_APP_TOKEN
  || "";